import { cn } from "@utils/cn";
import { HTMLAttributes } from 'react';

export const TableHead = ({
    className,
    ...props
}: HTMLAttributes<HTMLTableSectionElement>) => (
    <thead className={cn('[&_tr]:border-b', className)} {...props} />
);
